import { Flex } from "@chakra-ui/react";
import { useState } from "react";
import { UserRole } from "../api/types";
import AnnouncementBanner from "../components/announcement/announcement-banner";
import BookingFilters from "../components/booking/booking-filters";
import BookingPaymentBar from "../components/booking/booking-payment-bar";
import BookingTable from "../components/booking/booking-table";
import { Filters } from "../components/booking/types";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import useAuthStore from "../store/auth";

const BookingPage = () => {
  const [filters, setFilters] = useState<Filters | undefined>(undefined);
  const [user] = useAuthStore(state => [state.user]);

  const handleFilterChange = (newFilters: Filters) => {
    setFilters(newFilters);
  };

  return (
    <>
      <Flex direction="column" minHeight="100vh">
        <Flex flex="1" direction="column">
          <Header />
          {user?.role === UserRole.USER && <AnnouncementBanner />}
          <BookingFilters onFilterChange={handleFilterChange} />
          {filters && <BookingTable filters={filters} />}
          <BookingPaymentBar />
        </Flex>
        <Footer />
      </Flex>
    </>
  );
};

export default BookingPage;
